import React from 'react';

function About() {
    return (
      <div>
        <div 
          className="home" 
          style={{ 
            backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/palais.jpeg)`, 
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          <div className="home_content">
            <div className="home_title">A propos</div>
          </div>
        </div>
  
        {/* Intro Section */}
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div className="intro_image">
                  <img 
                    src={`${process.env.PUBLIC_URL}/assets/images/intro.png`} 
                    alt="Intro" 
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="intro_content">
                  <div className="intro_title"><span style={{
                  fontFamily: 'Dancing Script, cursive',
                  fontSize: '50px',
                  marginLeft: '5px',
                  textTransform: 'none',
                  wordSpacing: '7px' // ajuste selon le rendu souhaité
                }}>
                  Your Travel Shop
                </span></div>
                  <p className="intro_text">
  			Your Travel Shop est une plateforme de voyages conçue par Madagascar Discovery Agency (MDA) pour faciliter l’expérience touristique à Madagascar. Intuitive et accessible, elle permet à tous les voyageurs – familles, professionnels, touristes et jeunes aventuriers – de planifier et réserver leurs séjours simplement.

  			Notre objectif est de rendre les services touristiques plus accessibles grâce à une solution digitale proposant des offres variées, des promotions intéressantes et des outils pratiques pour comparer et gérer ses réservations.

  			En collaboration avec des compagnies aériennes, des hôtels, des agences de location et d’autres partenaires du secteur, nous proposons une offre complète et adaptée aux besoins de chacun. Sensibles aux enjeux environnementaux, nous encourageons des pratiques respectueuses du patrimoine naturel et culturel.

  			Avec Your Travel Shop, partez à la découverte de Madagascar avec un service fiable, accessible et pensé pour vous.
		</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default About;
  
